import React from 'react';
import Button,{
    buttonTypes,
    buttonSizes,
    buttonTextSizes} from './Button';
import { Link } from 'react-router-dom';

function BreadCrumb(props){
    const { linkArr } = props;

    return(
    <React.Fragment>
        {linkArr.map((l, index)=>{
            return(
            <React.Fragment>
                <div data-test="link">
                    { l.type === "react" ? (
                        <Link to={l.link}>
                            <Button text={l.display}
                                buttonType={buttonTypes.blueReversed}
                                buttonSize={buttonSizes.extraSmall}
                                buttonTextSize={buttonTextSizes.mediumSmall}
                                additionalStyles=""/>
                        </Link>
                        ):(
                        <a key={Math.floor(Math.random() * 20).toString()} href={l.link}>
                            <Button text={l.display}
                                buttonType={buttonTypes.blueReversed}
                                buttonSize={buttonSizes.extraSmall}
                                buttonTextSize={buttonTextSizes.mediumSmall}
                                additionalStyles=""/>
                        </a>)
                        }
                    </div>
                    { index === linkArr.length-1? "" : <div key={Math.floor(Math.random() * 20).toString()} style={{alignSelf:"center"}}>{">"}</div>}
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );

}

export default BreadCrumb;